import React from 'react';
import { Icon } from '../icons';
import type { IconName } from '../icons/types';
import styles from './Button.module.css';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'success' | 'ghost' | 'steam';
  size?: 'sm' | 'md' | 'lg';
  loading?: boolean;
  disabled?: boolean;
  icon?: IconName;
  iconPosition?: 'left' | 'right';
  fullWidth?: boolean;
  children?: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  icon,
  iconPosition = 'left',
  fullWidth = false,
  children,
  className,
  ...props
}) => {
  const isIconOnly = icon && !children;

  const buttonClasses = [
    styles.button,
    styles[variant],
    styles[size],
    fullWidth && styles.fullWidth,
    loading && styles.loading,
    disabled && styles.disabled,
    isIconOnly && styles.iconOnly,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const showIcon = icon && !loading;
  const showSpinner = loading;

  return (
    <button className={buttonClasses} disabled={disabled || loading} {...props}>
      {showSpinner && <Icon name="loading" className={styles.spinner} />}

      {isIconOnly ? (
        showIcon && <Icon name={icon} className={styles.iconOnly} />
      ) : (
        <>
          {showIcon && iconPosition === 'left' && (
            <Icon name={icon} className={styles.icon} />
          )}

          <span className={styles.content}>{children}</span>

          {showIcon && iconPosition === 'right' && (
            <Icon name={icon} className={styles.icon} />
          )}
        </>
      )}
    </button>
  );
};
